import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useScaleToFit } from '../hooks/useScaleToFit';
import { scrollToForm } from '../utils/scroll';
const AD_SIZE = 1080;
const DOCTOR_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/d0151ae3-4e58-46c8-a069-77c8b9161d38.jpg';
export function TestimonialAd() {
  const {
    ref,
    scale
  } = useScaleToFit(AD_SIZE);
  return <div ref={ref} className="aspect-square w-full overflow-hidden rounded-2xl shadow-brand" data-id="element-344" data-mp="cz6p5fo8niv">
      <div style={{
      width: AD_SIZE,
      height: AD_SIZE,
      transform: `scale(${scale})`,
      transformOrigin: 'top left'
    }} className="relative overflow-hidden bg-white font-sans" data-id="element-345" data-mp="3rjjri7f4uz7g">
        {/* Banda lateral de acento */}
        <div aria-hidden="true" className="absolute inset-y-0 left-0 z-20 w-2 bg-brand-blue" data-id="element-346" data-mp="3drvgy8kj8isl" />

        {/* MITAD SUPERIOR — Foto */}
        <div className="relative h-[540px] w-full overflow-hidden bg-white" data-id="element-347" data-mp="v57zs2vv3dfr">
          <img src={DOCTOR_IMAGE} alt="Dra. María G., dentista de Sonrisas Dental, en su clínica en Chicago" loading="lazy" decoding="async" className="h-full w-full object-cover object-[35%_25%]" data-id="element-348" data-mp="z7cnkkzmpfuh" />
          <div className="absolute right-12 top-12 flex h-[156px] w-[156px] -rotate-6 flex-col items-center justify-center rounded-full bg-brand-red text-center font-display text-[26px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_16px_40px_rgba(233,30,99,0.45)] ring-4 ring-white/70" data-id="element-349" data-mp="18zidzqa8fp7k">
            <span data-id="element-350" data-mp="q6wodnpx4uvf">Caso</span>
            <span data-id="element-351" data-mp="q87qzk7mnwky">Real</span>
          </div>
        </div>

        {/* MITAD INFERIOR — Testimonio */}
        <div className="relative flex h-[460px] flex-col overflow-hidden bg-brand-blue px-16 pb-9 pt-10" data-id="element-352" data-mp="1wm72wvxnshxo">
          <span aria-hidden="true" className="pointer-events-none absolute left-10 top-[-70px] font-serif text-[280px] leading-none text-white/10" data-id="element-353" data-mp="21l1tik1vbasc">
            “
          </span>

          <p className="relative font-display text-[42px] font-extrabold leading-tight text-white" data-id="element-354" data-mp="16yl81mwk241m">
            En 3 semanas me llegaron
          </p>

          <div className="relative mt-2 flex items-center gap-6" data-id="element-355" data-mp="1gwr61tf8qq17">
            <span className="font-display text-[120px] font-extrabold leading-[0.9] text-brand-yellow" data-id="element-356" data-mp="1gv7s49h24r2l">
              9
            </span>
            <span className="font-display text-[42px] font-extrabold leading-[1.15] text-white" data-id="element-357" data-mp="o950ifmgdbbp">
              pacientes nuevos
              <br data-id="element-358" data-mp="12yaxdwxtipgf" />
              de Google.
            </span>
          </div>

          <p className="relative mt-4 text-[24px] font-medium text-white/80" data-id="element-359" data-mp="y6j9xv9ykzui">
            Todos dijeron lo mismo:
          </p>
          <p className="relative mt-1 text-[30px] font-semibold italic text-brand-yellow" data-id="element-360" data-mp="afngktputwl5">
            “Su clínica se veía muy profesional.”
          </p>

          <div className="relative mt-4 flex gap-1 text-brand-yellow" aria-label="5 de 5 estrellas" data-id="element-361" data-mp="2h4yxykvs7sw3">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} style={{
            fontSize: 34
          }} data-id="element-362" data-mp="277t79dr2y3we" data-mpi={index} />)}
          </div>

          <div className="relative mt-auto flex items-end justify-between gap-8" data-id="element-363" data-mp="2c64fjk1q86ci">
            <div data-id="element-364" data-mp="2zvytk4xs80yc">
              <p className="font-display text-[30px] font-extrabold leading-tight text-white" data-id="element-365" data-mp="2zvgpwn8sikge">
                — Dra. María G.
              </p>
              <p className="text-[22px] font-semibold text-[#9CC0FF]" data-id="element-366" data-mp="34ujmdjapficr">
                Dentista · Chicago
              </p>
            </div>
            <button type="button" onClick={scrollToForm} className="inline-flex flex-shrink-0 items-center gap-3 rounded-full bg-brand-yellow px-8 py-4 font-display text-[26px] font-extrabold text-brand-deep transition hover:bg-brand-yellow-dark" data-id="element-367" data-mp="2uwlw6q9abbhi">
              <RocketLaunchIcon style={{
              fontSize: 28
            }} data-id="element-368" data-mp="1zolc2rfy4t9r" />
              Ver Mi Precio →
            </button>
          </div>
        </div>

        {/* BANNER INFERIOR */}
        <div className="flex h-20 items-center justify-center bg-brand-deep px-16 text-center text-[22px] font-semibold text-white" data-id="element-369" data-mp="1uw1xps9fpu3w">
          Ultimate Web Creator · Webs profesionales en 7 días desde $600.
        </div>
      </div>
    </div>;
}